/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
import $ from "jquery"
$(function () {
    waitForElementToDisplay(".desktop-image", tabs, 1000, 9000);
});

const isResponsiveXS = window.matchMedia("(min-width: 320px)").matches;
const isResponsiveSM = window.matchMedia("(min-width: 768px)").matches;
const isResponsiveMD = window.matchMedia("(min-width: 1050px)").matches;
const isResponsiveXL = window.matchMedia("(min-width: 1280px)").matches;

const tabs = () => {
    const $tabContentObj = $(".clf-tab-content");
    let backgroundImage = $("#tab-1 .content-picture .desktop-image").attr("data-src");

    if (isResponsiveXL) {
        backgroundImage = $("#tab-1 .content-picture .desktop-image").attr("data-src");
        $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${backgroundImage}")`);
    } else
        if (isResponsiveMD) {
            backgroundImage = $("#tab-1 .content-picture .md-image").attr("data-src");
            $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${backgroundImage}")`);
        } else
            if (isResponsiveSM) {
                backgroundImage = $("#tab-1 .content-picture .sm-image").attr("data-src");
                $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${backgroundImage}")`);
            } else
                if (isResponsiveXS) {
                    backgroundImage = $("#tab-1 .content-picture .mobile-image").attr("data-src");
                    $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${backgroundImage}")`);
                }
    $(".clf2020-switch-tabs .clf-tabs li").click(function (event) {
        event.stopPropagation();
        onChangeTabClick($tabContentObj, $(this))
    });

    $(".clf2020-switch-tabs .clf-tabs li").keydown(function (event) {
        if (event.keyCode === 13) {
            onChangeTabClick($tabContentObj, $(this))
        }
    });
}

const onChangeTabClick = ($tabContentObj, $this) => {
    $tabContentObj.hide();
    $("ul.clf-tabs").find("li.selected").removeClass("selected");
    $(".clf2020-switch-tabs").find("div.bg-selected").removeClass("bg-selected");
    const currentAncorObj = $this.find("a");
    currentAncorObj.parent().parent().addClass("selected");

    const currentTab = currentAncorObj.attr("class");
    let imageUrl = $(`#${currentTab} .content-picture .desktop-image`).attr("data-src");

    $(`#${currentTab}`).show("slow");

    if (isResponsiveXL) {
        imageUrl = $(`#${currentTab} .content-picture .desktop-image`).attr("data-src");
        $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${imageUrl}")`);
    } else
        if (isResponsiveMD) {
            imageUrl = $(`#${currentTab} .content-picture .md-image`).attr("data-src");
            $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${imageUrl}")`);
        } else
            if (isResponsiveSM) {
                imageUrl = $(`#${currentTab} .content-picture .sm-image`).attr("data-src");
                $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${imageUrl}")`);
            } else
                if (isResponsiveXS) {
                    imageUrl = $(`#${currentTab} .content-picture .mobile-image`).attr("data-src");
                    $(".clf2020-switch-tabs-container").css("backgroundImage", `url("${imageUrl}")`);
                }
}

function loopSearch(selector, callback, checkFrequencyInMs, timeoutInMs, startTimeInMs) {
    if (!!document.querySelector(selector)) {
        callback();
        return;
    }
    else {
        setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                return;
            loopSearch();
        }, checkFrequencyInMs);
    }
}

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    const startTimeInMs = Date.now();
    loopSearch(selector, callback, checkFrequencyInMs, timeoutInMs, startTimeInMs);
}